import { z } from 'zod';

import { flagKeySchema, variantKeySchema } from './ids';
import { analyticsSubjectIdSchema } from './subject';
import { sanitizeProductProperties } from './rich-properties';

export const featureFlagValueSchema = z.union([z.boolean(), variantKeySchema]);
export const analyticsPersonPropertiesSchema = z
  .record(z.string(), z.unknown())
  .transform((value, context) => {
    try {
      return sanitizeProductProperties(value).properties;
    } catch (error) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: error instanceof Error ? error.message : 'Invalid analytics person properties',
      });
      return z.NEVER;
    }
  });

export const analyticsContextSchema = z
  .object({
    subject_id: analyticsSubjectIdSchema,
    person_properties: analyticsPersonPropertiesSchema.default({}),
    flags: z.partialRecord(flagKeySchema, featureFlagValueSchema),
    flag_evaluations: z.partialRecord(
      flagKeySchema,
      z
        .object({
          value: featureFlagValueSchema,
          source: z.enum(['server', 'default']),
          used_default: z.boolean(),
        })
        .strict(),
    ),
    evaluated_at: z.string().datetime(),
    snapshot_version: z.string().min(1).max(120),
  })
  .strict();

export type AnalyticsContext = z.infer<typeof analyticsContextSchema>;
